import React from "react";
import { FaCheck } from "react-icons/fa";

const CheckboxWithLabel = ({ label, checked, onChange }) => {
  return (
    <label className="flex items-center gap-fluid-1.5 cursor-pointer group p-fluid-0.5">
      {/* Checkbox Container */}
      <div className={`relative w-fluid-icon-md h-fluid-icon-md border-2 rounded-sm flex items-center justify-center 
        transition-all duration-200 transform active:scale-95
        ${checked 
          ? 'bg-[#223688] border-[#223688]' 
          : 'border-gray-400 group-hover:border-[#223688]'}`}
      >
        {checked && (
          <FaCheck className="text-white w-fluid-icon-xs h-fluid-icon-xs transition-all duration-150" />
        )}
      </div>
      
      {/* Label Text */}
      <span className="text-fluid-sm font-medium text-gray-700 group-hover:text-[#223688] 
        transition-colors duration-200 truncate">
        {label}
      </span>
      
      {/* Hidden Input */}
      <input
        type="checkbox"
        className="sr-only"
        checked={checked}
        onChange={onChange}
        aria-label={label}
      />
    </label>
  );
};

export default CheckboxWithLabel;